import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Context } from '../../context/Contex';
import serviceLines from '../../services/serviceLines';
import LinesPage from '../../pages/MaestrosPage/LinesPage/LinesPage';

const LinesCointainer = () => {
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(false);
  const { permisos } = useContext(Context);
  const history = useHistory();
  const dataLines = [];

  /*= =======================================================================
  Get getLines
====================================================== ================== */
  const getLines = () => {
    setLoading(true);
    serviceLines.getLines()
      .then((response) => {
        setLines(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        history.push('/home');
        setLoading(false);
      });
  };

  useEffect(() => {
    getLines();
  }, []);

  /*= =======================================================================
  Update Precios
========================================================================= */
  const hadleUpdate = (params) => {
    setLoading(true);
    serviceLines.putLines(params)
      .then(() => {
        getLines();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  if (lines) {
    try {
      lines.forEach((value) => {
        dataLines.push({
          id: value.id,
          linea: value.linea,
          nombre_comercial: value.nombre_comercial,
        });
      });
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <LinesPage
        lines={dataLines}
        permisos={permisos}
        onUpdate={hadleUpdate}
        loading={loading}
      />
    </>
  );
};

export default LinesCointainer;
